import { Expose } from 'class-transformer';
import { BaseEntity } from './base.entity';

export class EncryptedCodeResponse extends BaseEntity {
  @Expose()
  public encrypted: string;
}
